import React       from 'react';
import classnames  from 'classnames';
import Label       from './Label';
import Tooltip     from './Tooltip';
import SelectInput from './SelectInput';

const SelectComponent = props => (
  <div className={classnames('form-group', props.className)}>
    <Label label={props.label} required={props.required}>
      <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} />
    </Label>
    <SelectInput {...props} className={classnames('form-control form-select', props.inputClassName)} />
    {props.children}
  </div>
);

SelectComponent.defaultProps = {
  label   : '',
  required: false,
  tooltip : '',
};

export default SelectComponent;
